import styled from 'styled-components';

export const Content = styled.div`
	padding: 40px 0 0;
`;

export const DrawerHeader = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 40px;
	padding: 0 24px;

	> span {
		${({ theme }) => theme.typography.headlines.h3};
		display: inline-flex;
		align-items: center;
	}
`;
